const MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']

/**
 * "21 Sep", with the year only when it is not this one: the chat's one date
 * style, as the server writes its facts (wave 23). Read from the ISO date
 * itself, so no time zone can move it a day.
 */
export function dayWords(iso: string, today = new Date()): string {
  const [year = 0, month = 1, day = 1] = iso.split('-').map(Number)
  const words = `${day} ${MONTHS[month - 1] ?? ''}`
  return year === today.getUTCFullYear() ? words : `${words} ${year}`
}
